export default __webpack_public_path__ + "rocket-dialog-background.png";